import {connect} from 'react-redux';
import MarketUpdate from '../components/market-update/';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    cmsStatic: state.store.config.cmsStatic
  };
};

export default connect(mapStateToProps)(MarketUpdate);



// WEBPACK FOOTER //
// ./src/containers/market-update.js